<template>
    <div>
        <h1>Választható Kiegészítő Fedezetek</h1>
        <div class="row p-3 mb-4">
            <div class="col-12 mb-3" v-for="(accesory, key) in accesoryList.showable" :key="key">
                <Accesory :accesory="accesory" :aKey="key" :selectable="true" />
            </div>
        </div>
        <div class="alert alert-light accesory-box mb-5">
            A Colonnade Minősített Fogyasztóbarát Otthonbiztosítás Kiegészítő fedezetei között nem vehetők igénybe a következők,
            illetve nem nyújt fedezetet az alábbiakra: lakóépületek rejtett hibáiból eredő károk, épülettartozékok lopása,
            klímaberendezés biztosítás, lábon álló növényzet biztosítása, hobbi- és kisállatbiztosítás, kiterjesztett garancia,
            okos eszközök biztosítás, elmaradt bérleti díj biztosítás, munkanélküliség biztosítás.
        </div>
    </div>
</template>

<script>
    import { mapFields } from 'vuex-map-fields'
    import Accesory from './components/Accesory'

    export default {
        components: {
            Accesory,
        },
        computed: {
            ...mapFields([
                'generalInfo.contractFor',
                'insuranceProperty.chosenInsurancePrice',
                'insurancePersonalGoods.calculatedInsurancePrice',
                'insurancePersonalGoods.acceptCalculatedInsurance',
                'insurancePersonalGoods.priceType',
                'insurancePersonalGoods.allGoodsPrice',
                'chooseableAccesories.valuablesAboveInputs',
            ]),
            ...mapFields({
                sideBuildings: 'insuranceSideBuildings.list',
                accesoriesList: 'chooseableAccesories.selectableList',
            }),
            accesoryList: function() {
                let showable = {}
                let notShowable = {}

                Object.entries(this.accesoriesList).forEach(accesory => {
                    if(accesory[1]?.showable?.includes(this.contractFor)) showable[accesory[0]] = accesory[1]
                    else notShowable[accesory[0]] = accesory[1]
                })

                return {
                    showable: showable,
                    notShowable: notShowable
                }
            }
        },
    }
</script>